"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var SideMenuItem = /*#__PURE__*/function (_Component) {
  _inherits(SideMenuItem, _Component);
  /**
   * Set initial state in constructor
   */


  function SideMenuItem() {
    var _this;

    _classCallCheck(this, SideMenuItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SideMenuItem).call(this));
    _this.state = {
      opened: false
    };
    return _this;
  }
  /**
   * Called on link click
   */


  _createClass(SideMenuItem, [{
    key: "linkClick",
    value: function linkClick() {
      this.setState({
        opened: !this.state.opened
      });
    }
    /**
     * Render function
     *
     * @returns {XML}
     */

  }, {
    key: "render",
    value: function render() {
      // Build icon
      var icon = 'fa fa-' + this.props.icon; // Build children

      var children = [];

      if (this.props.children) {
        this.props.children.map(function (child, index) {
          var key = 'side-menu-item-' + index;
          children.push(_react["default"].createElement(SideMenuItem, _extends({}, child, {
            key: key
          })));
        });
      } // Check if item is active


      var isActive = this.isPathActive(this.props); // Check if item should be opened

      var opened = false;

      if (isActive) {
        opened = true;
      } // Get children components


      var childPart = '';
      var path = this.props.path;

      if (children.length) {
        childPart = _react["default"].createElement("ul", {
          className: "sub-nav",
          style: {
            display: opened ? 'block' : 'display-none'
          }
        }, children);
      }

      var innerComponent = null;

      if (path) {
        innerComponent = _react["default"].createElement(_reactRouterDom.Link, {
          to: path,
          onClick: this.linkClick.bind(this)
        }, _react["default"].createElement("i", {
          "data-toggle": "tooltip",
          "data-placement": "right",
          title: this.props.label,
          className: icon,
          "aria-hidden": "true"
        }), _react["default"].createElement("span", null, this.props.label), children.length ? _react["default"].createElement("i", {
          className: 'fa fa-angle-left arrow' + (opened ? ' arrow-down' : ''),
          "aria-hidden": "true"
        }) : null);
      } else {
        innerComponent = _react["default"].createElement("a", {
          href: "javascript:void(0)",
          onClick: this.linkClick.bind(this)
        }, _react["default"].createElement("i", {
          "data-toggle": "tooltip",
          "data-placement": "right",
          title: this.props.label,
          className: icon,
          "aria-hidden": "true"
        }), _react["default"].createElement("span", null, this.props.label), children.length ? _react["default"].createElement("i", {
          className: 'fa fa-angle-left arrow' + (opened ? ' arrow-down' : ''),
          "aria-hidden": "true"
        }) : null);
      } // Render item


      return _react["default"].createElement("li", {
        className: isActive ? 'active' : null
      }, innerComponent, childPart);
    }
    /**
     * Check if path is active
     *
     * @param item
     * @returns {boolean}
     */

  }, {
    key: "isPathActive",
    value: function isPathActive(item) {
      // Get current path from context
      // let currentPath = this.context.router.route.location.pathname;
      var currentPath = window.location.pathname; // If paths same?

      if (currentPath === item.path) {
        return true;
      } // Check if some child is active


      if (item.children) {
        for (var i = 0; i < item.children.length; i++) {
          var childActive = this.isPathActive(item.children[i]);

          if (childActive) {
            return true;
          }
        }
      } // Default false


      return false;
    }
  }]);

  return SideMenuItem;
}(_react.Component);

exports["default"] = SideMenuItem;
SideMenuItem.contextTypes = {
  router: _propTypes["default"].object
};